import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import {Box, Button, Menu, MenuItem} from '@mui/material';
import {
  ComponentProps,
  JSXElementConstructor,
  ReactNode,
  useState,
} from 'react';

import {buildHistoryReportUrl} from '../../utils/historyReportUrl';

type ComponentType = keyof JSX.IntrinsicElements | JSXElementConstructor<any>;

interface Props<T extends ComponentType> {
  setViewType: Function;
  alarmId?: number | string;
  component?: T;
  componentProps?: ComponentProps<T>;
  children?: ReactNode;
}

const AlarmItemHistoryButton = <T extends ComponentType = typeof Button>({
  component,
  componentProps,
  children,
  setViewType,
  alarmId,
}: // onPurged,
Props<T>) => {
  const Component = component ?? Button;
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const menuOpen = Boolean(anchorEl);

  const openInNewTab = (type: 'alarm' | 'alarm_log') => {
    if (alarmId === undefined || alarmId === null) {
      return;
    }
    const url = buildHistoryReportUrl(type, alarmId);
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <>
      <Component
        {...componentProps}
        onClick={(event) => setAnchorEl(event.currentTarget)}
      >
        {children}
      </Component>

      <Menu
        anchorEl={anchorEl}
        open={menuOpen}
        onBackdropClick={() => setAnchorEl(null)}
      >
        <MenuItem
          onClick={() => {
            setViewType('alarm');
            setAnchorEl(null);
          }}
        >
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            width="100%"
            gap={1}
          >
            <span>View Alarm History</span>
            {alarmId !== undefined && alarmId !== null ? (
              <OpenInNewIcon
                fontSize="small"
                onClick={(event) => {
                  event.stopPropagation();
                  openInNewTab('alarm');
                  setAnchorEl(null);
                }}
                aria-label="Open in new tab"
                sx={{cursor: 'pointer', color: 'text.secondary'}}
              />
            ) : null}
          </Box>
        </MenuItem>
        <MenuItem
          onClick={() => {
            setViewType('alarm_log');
            setAnchorEl(null);
          }}
        >
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            width="100%"
            gap={1}
          >
            <span>View Alarm Log</span>
            {alarmId !== undefined && alarmId !== null ? (
              <OpenInNewIcon
                fontSize="small"
                onClick={(event) => {
                  event.stopPropagation();
                  openInNewTab('alarm_log');
                  setAnchorEl(null);
                }}
                aria-label="Open in new tab"
                sx={{cursor: 'pointer', color: 'text.secondary'}}
              />
            ) : null}
          </Box>
        </MenuItem>
      </Menu>
    </>
  );
};

export default AlarmItemHistoryButton;
